"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var framer_motion_1 = require("framer-motion");
var react_1 = __importStar(require("react"));
var select_context_1 = require("../../select.context");
var S = __importStar(require("../common.styled"));
var animations_1 = require("./animations");
var LoadingOptions_1 = __importDefault(require("./LoadingOptions"));
var NoOption_1 = __importDefault(require("./NoOption"));
var Options_1 = __importDefault(require("./Options"));
var StaticOptions = function (_a) {
    var onSearch = _a.onSearch, loadingOptionsLabel = _a.loadingOptionsLabel, isSearching = _a.isSearching;
    var _b = __read(react_1.default.useState(false), 2), isAsyncLoading = _b[0], setIsAsyncLoading = _b[1];
    var _c = (0, select_context_1.useSelect)(), optionsVisible = _c.optionsVisible, options = _c.options, searchFilter = _c.searchFilter;
    var contentOptionRef = react_1.default.useRef(null);
    var renderOptions = react_1.default.useCallback(function (filter) {
        if (filter === void 0) { filter = ''; }
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (isSearching !== undefined)
                            setIsAsyncLoading(true);
                        return [4 /*yield*/, onSearch(filter)];
                    case 1:
                        _a.sent();
                        if (isSearching !== undefined)
                            setIsAsyncLoading(false);
                        return [2 /*return*/];
                }
            });
        });
    }, [onSearch, options, isSearching]);
    (0, react_1.useEffect)(function () {
        renderOptions(searchFilter);
    }, [searchFilter]);
    return (react_1.default.createElement(framer_motion_1.AnimatePresence, null, optionsVisible && (react_1.default.createElement(S.ContentOption, { variants: animations_1.dropDownAnimationWithLoading, initial: "initial", animate: "animateOptions", exit: "exit", ref: contentOptionRef },
        react_1.default.createElement(S.ContentScroll, null,
            !isAsyncLoading && react_1.default.createElement(Options_1.default, { onSearch: onSearch }),
            react_1.default.createElement(NoOption_1.default, { optionsToRender: options, loading: isSearching || isAsyncLoading }),
            react_1.default.createElement(LoadingOptions_1.default, { loading: isSearching || isAsyncLoading, loadingOptionsLabel: loadingOptionsLabel }))))));
};
exports.default = StaticOptions;
